import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FreshReworkBarChart from "examples/Charts/BarCharts/FreshReworkBarChart";
import ActivityEfficiencyBarChart from "examples/Charts/BarCharts/ActivityEfficiencyBarChart";
import WaitingHoursBarChart from "examples/Charts/BarCharts/WaitingHoursBarChart";
import { supervisorDashboardData } from "actions/dashboard";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShiftList } from "actions/shift";
import MDButton from "components/MDButton";
import { Card, Grid, TextField, Autocomplete, Icon } from "@mui/material";
import { useNotify } from "components/CommonComponent/NotificationProvider";
import { activityTypeOptions } from "components/common/constant";
import { getProductList } from "actions/product";
import { getUnitListing } from "actions/unit";
import { getDutyTypeList } from "actions/dutyType";
import { getSubActivityUniqueList } from "actions/subActivity";
import { getProjectList } from "actions/project";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { DATE_RANGE_OPTIONS, REMARK_OPTIONS } from "components/common/constant";
import Typography from "@mui/material/Typography";
// import { DASHBOARD_STATUS } from "components/common/constant";

function SupervisorDashboard() {
  const { notify } = useNotify();
  const dispatch = useDispatch();
  const [efficiencyChartData, setEfficiencyChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Efficiency %",
        backgroundColor: "#156082",
        data: [],
      },
    ],
  });
  const [reworkChartData, setReworkChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Rework %",
        backgroundColor: "#156082",
        data: [],
      },
    ],
  });
  const [freshReworkChartData, setFreshReworkChartData] = useState({
    labels: ["Hours"],
    datasets: [],
  });
  const [projectHoursChartData, setProjectHoursChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Hours",
        backgroundColor: "#156082",
        data: [],
      },
    ],
  });
  const [filters, setFilters] = useState(() => {
    const endDate = new Date();
    const startDate = new Date();

    return {
      dateRange: "TODAY",
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      shiftIDs: [],
      activityType: "",
      typeOfProduct: null,
      unitID: null,
      dutyTypeID: null,
      subActivityID: null,
      projectID: null,
      lhbActivityType: "",
      //status: "ACTIVE",
      isSearched: false,
    };
  });
  const [listState, setListState] = useState({
    showLoaderOnClick: false,
  });
  const [subActivityHoursChartData, setSubActivityHoursChartData] = useState({
    labels: [],
    datasets: [],
  });

  const [appliedDateRange, setAppliedDateRange] = useState({
    startDate: filters.startDate,
    endDate: filters.endDate,
  });

  const shiftListData = useSelector((state) => state.shift.shiftList);

  const productListData = useSelector((state) => state.product.productList);

  const unitListingData = useSelector((state) => state.unit.unitList);

  const dutyTypeListData = useSelector((state) => state.dutyType.dutyTypeList);

  const subActivityData = useSelector(
    (state) => state.subActivity.subActivityUniqueList,
  );

  const projectListData = useSelector((state) => state.project.projectList);

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    getShiftList(dispatch);
    getProductList(dispatch);
    getUnitListing(dispatch);
    getDutyTypeList(dispatch);
    getSubActivityUniqueList(dispatch);
    getProjectList(dispatch);
  }, [dispatch]);

  const getDateRange = (days) => {
    const today = new Date();

    if (days === "TODAY") {
      const todayString = dayjs(today).format("YYYY-MM-DD");

      return {
        startDate: todayString,
        endDate: todayString,
      };
    }

    const endDate = new Date(today);
    endDate.setDate(endDate.getDate() - 1);

    if (days === "1") {
      const yesterdayString = dayjs(endDate).format("YYYY-MM-DD");

      return {
        startDate: yesterdayString,
        endDate: yesterdayString,
      };
    }

    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - (Number(days) - 1));

    return {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
  };

  const shiftOptions =
    shiftListData?.data?.shift?.map((item) => ({
      id: item.ID,
      name: item.name,
    })) || [];

  const productOptions =
    productListData?.data?.Product?.map((item) => ({
      id: item.ID,
      name: item.type,
    })) || [];

  const unitOptions =
    unitListingData?.data?.Unit?.map((item) => ({
      id: item.ID,
      name: item.unitNo,
    })) || [];

  const dutyTypeOptions =
    dutyTypeListData?.data?.DutyType?.map((item) => ({
      id: item.ID,
      name: item.name,
    })) || [];

  const subActivityOptions =
    subActivityData?.data?.map((item) => ({
      id: item.ID,
      name: item.name,
    })) || [];

  const projectOptions =
    projectListData?.data?.project?.map((item) => ({
      id: item.ID,
      name: item.projectNo,
    })) || [];

  const getDashboardData = async (customPayload = null) => {
    try {
      setListState((prev) => ({
        ...prev,
        showLoaderOnClick: true,
      }));

      const payload = customPayload || {
        startDate: filters.startDate,
        endDate: filters.endDate,
        shiftID: filters.shiftIDs,
        activityType: filters.activityType !== "" ? [filters.activityType] : [],
        projectID: filters.projectID ? [filters.projectID] : [],
        unitID: filters.unitID ? [filters.unitID] : [],
        dutyTypeID: filters.dutyTypeID ? [filters.dutyTypeID] : [],
        productTypeID: filters.typeOfProduct ? [filters.typeOfProduct] : [],
        subActivityTypeID: filters.subActivityID ? [filters.subActivityID] : [],
        lhbActivityType: filters.lhbActivityType || "",
        // status: filters.status,
      };

      const response = await supervisorDashboardData(payload);

      if (response?.code !== 200) {
        notify(
          Array.isArray(response?.message)
            ? response.message.map((e) => e.Msg).join(", ")
            : response?.message,
          "error",
        );
        return;
      }

      const projectHoursData =
        response?.data?.project_wise_direct_hours_report ?? [];

      setProjectHoursChartData({
        labels: projectHoursData.map((item) => item.project_no),
        datasets: [
          {
            label: "Hours",
            backgroundColor: "#156082",
            data: projectHoursData.map((item) => Number(item.hours)),
          },
        ],
      });

      const subActivityHoursData =
        response?.data?.sub_activity_hours_report ?? [];

      setSubActivityHoursChartData({
        labels: subActivityHoursData.map((item) => item.sub_activity_name),
        datasets: [
          {
            label: "Hours",
            backgroundColor: "#156082",
            data: subActivityHoursData.map((item) => Number(item.hours)),
          },
        ],
      });

      const efficiencyData = response?.data?.efficiency_report ?? [];

      setEfficiencyChartData({
        labels: efficiencyData.map((item) => item.department_name),
        datasets: [
          {
            label: "Efficiency %",
            backgroundColor: "#156082",
            data: efficiencyData.map((item) => Number(item.efficiency_rate)),
          },
        ],
      });

      const reworkData = response?.data?.rework_report ?? [];

      setReworkChartData({
        labels: reworkData.map((item) => item.department_name),
        datasets: [
          {
            label: "Rework %",
            backgroundColor: "#156082",
            data: reworkData.map((item) => Number(item.rework_rate)),
          },
        ],
      });

      const activityHoursData = response?.data?.activity_hours_report ?? [];

      const freshDepartmentData =
        activityHoursData.find((item) => item.activity_type === "FRESH")
          ?.departmentwise ?? [];

      const reworkDepartmentData =
        activityHoursData.find((item) => item.activity_type === "REWORK")
          ?.departmentwise ?? [];

      const labels = [
        ...new Set([
          ...freshDepartmentData.map((item) => item.department_name),
          ...reworkDepartmentData.map((item) => item.department_name),
        ]),
      ];

      setFreshReworkChartData({
        labels,
        datasets: [
          {
            label: "Fresh",
            backgroundColor: "#156082",
            data: labels.map((department) => {
              const item = freshDepartmentData.find(
                (d) => d.department_name === department,
              );
              return item ? Number(item.hours) : 0;
            }),
          },
          {
            label: "Rework",
            backgroundColor: "#ED7D31",
            data: labels.map((department) => {
              const item = reworkDepartmentData.find(
                (d) => d.department_name === department,
              );
              return item ? Number(item.hours) : 0;
            }),
          },
        ],
      });
    } catch (error) {
      notify(error?.message || "Something went wrong", "error");
    } finally {
      setListState((prev) => ({
        ...prev,
        showLoaderOnClick: false,
      }));
    }
  };

  const handleSearch = () => {
    setAppliedDateRange({
      startDate: filters.startDate,
      endDate: filters.endDate,
    });
    getDashboardData();

    setFilters((prev) => ({
      ...prev,
      isSearched: true,
    }));
  };

  const handleClear = () => {
    const endDate = new Date();
    const startDate = new Date();

    const resetFilters = {
      dateRange: "TODAY",
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      shiftIDs: [],
      activityType: "",
      typeOfProduct: null,
      unitID: null,
      dutyTypeID: null,
      subActivityID: null,
      lhbActivityType: "",
      // status: filters.status,
      projectID: null,
      isSearched: false,
    };

    setAppliedDateRange({
      startDate: resetFilters.startDate,
      endDate: resetFilters.endDate,
    });

    setFilters(resetFilters);

    getDashboardData({
      startDate: resetFilters.startDate,
      endDate: resetFilters.endDate,
      shiftIDs: [],
      activityType: [],
      unitID: null,
      dutyTypeID: null,
      subActivityID: null,
      productID: null,
      projectID: null,
      lhbActivityType: "",
      // status: resetFilters.status,
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={DATE_RANGE_OPTIONS}
                      value={
                        DATE_RANGE_OPTIONS.find(
                          (item) => item.value === filters.dateRange,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => {
                        if (!value) return;

                        if (value.value === "CUSTOM") {
                          setFilters({
                            ...filters,
                            dateRange: "CUSTOM",
                          });
                        } else {
                          const dates = getDateRange(value.value);

                          setFilters({
                            ...filters,
                            dateRange: value.value,
                            startDate: dates.startDate,
                            endDate: dates.endDate,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Date Range"
                        />
                      )}
                    />
                  </Grid>
                  {filters.dateRange === "CUSTOM" && (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="Start Date"
                            value={dayjs(filters.startDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                startDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="End Date"
                            minDate={dayjs(filters.startDate)}
                            value={dayjs(filters.endDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                endDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={shiftOptions}
                      value={
                        shiftOptions.find(
                          (item) => item.id === filters.shiftIDs?.[0],
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          shiftIDs: value ? [value.id] : [],
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Shift" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={activityTypeOptions}
                      value={
                        activityTypeOptions.find(
                          (item) => item.value === filters.activityType,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          activityType: value?.value || "",
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Activity Type"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={productOptions}
                      value={
                        productOptions.find(
                          (item) => item.name === filters.typeOfProduct,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          typeOfProduct: value?.name || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Product Type"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={unitOptions}
                      value={
                        unitOptions.find(
                          (item) => item.id === filters.unitID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          unitID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Unit" />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={dutyTypeOptions}
                      value={
                        dutyTypeOptions.find(
                          (item) => item.id === filters.dutyTypeID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          dutyTypeID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Duty Type" />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={subActivityOptions}
                      value={
                        subActivityOptions.find(
                          (item) => item.name === filters.subActivityID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          subActivityID: value?.name || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Sub Activity"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={projectOptions}
                      value={
                        projectOptions.find(
                          (item) => item.id === filters.projectID,
                        ) || null
                      }
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          projectID: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project Number"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={REMARK_OPTIONS}
                      value={
                        REMARK_OPTIONS.find(
                          (item) => item.value === filters.lhbActivityType,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          lhbActivityType: value?.value || "",
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Remark" />
                      )}
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      disablePortal
                      size="small"
                      options={DASHBOARD_STATUS}
                      value={
                        DASHBOARD_STATUS.find(
                          (item) => item.value === filters.status,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label || ""}
                      onChange={(event, value) =>
                        setFilters({
                          ...filters,
                          status: value?.value || "ACTIVE",
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Status" />
                      )}
                    />
                  </Grid> */}

                  <Grid item xs={12} sm={6} md={4} lg="auto">
                    <MDBox
                      display="flex"
                      flexDirection={
                        filters.dateRange === "CUSTOM" ? "column" : "row"
                      }
                      gap={1}
                      width="100%"
                    >
                      <MDButton
                        variant="contained"
                        color="deepBlue"
                        sx={{
                          minWidth: "120px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={handleSearch}
                        disabled={listState.showLoaderOnClick}
                      >
                        {listState.showLoaderOnClick ? (
                          <i className="fa fa-spinner fa-spin fa-lg text-white" />
                        ) : (
                          <>
                            <Icon sx={{ mr: 1 }}>search</Icon>
                            Search
                          </>
                        )}
                      </MDButton>

                      {filters.isSearched && (
                        <MDButton
                          variant="contained"
                          color="deepBlue"
                          sx={{
                            minWidth: "120px",
                            whiteSpace: "nowrap",
                          }}
                          onClick={handleClear}
                        >
                          <Icon sx={{ mr: 1 }}>close</Icon>
                          Clear
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                  {/* <Grid item xs={12}>
                    <MDBox mt={-1}>
                      <Typography variant="caption" color="text">
                        {appliedDateRange.startDate ===
                        appliedDateRange.endDate ? (
                          <>
                            Showing data for{" "}
                            <strong>
                              {dayjs(appliedDateRange.startDate).format(
                                "DD-MMM-YYYY",
                              )}
                            </strong>
                          </>
                        ) : (
                          <>
                            Showing data from{" "}
                            <strong>
                              {dayjs(appliedDateRange.startDate).format(
                                "DD-MMM-YYYY",
                              )}
                            </strong>{" "}
                            to{" "}
                            <strong>
                              {dayjs(appliedDateRange.endDate).format(
                                "DD-MMM-YYYY",
                              )}
                            </strong>
                          </>
                        )}
                      </Typography>
                    </MDBox>
                  </Grid> */}
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3} mt={0.3}>
          <Grid item xs={4}>
            <Card>
              <MDBox px={3} py={1.5}>
                <Typography variant="body2" fontWeight="bold">
                  {
                    DATE_RANGE_OPTIONS.find(
                      (item) => item.value === filters.dateRange,
                    )?.label
                  }
                </Typography>

                <Typography variant="caption" color="text">
                  {appliedDateRange.startDate === appliedDateRange.endDate
                    ? dayjs(appliedDateRange.startDate).format("DD-MMM-YYYY")
                    : `${dayjs(appliedDateRange.startDate).format("DD-MMM-YYYY")} to ${dayjs(
                        appliedDateRange.endDate,
                      ).format("DD-MMM-YYYY")}`}
                </Typography>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <ActivityEfficiencyBarChart
                  color="light"
                  title="Rework %"
                  description=""
                  date=""
                  chart={reworkChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <ActivityEfficiencyBarChart
                  color="light"
                  title="Efficiency %"
                  description=""
                  date=""
                  chart={efficiencyChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <FreshReworkBarChart
                  color="light"
                  title="Fresh vs Rework Hours"
                  description=""
                  date=""
                  showHours
                  chart={freshReworkChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <WaitingHoursBarChart
                  color="light"
                  title="Project-wise Hours Allocation"
                  description=""
                  date=""
                  chart={projectHoursChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3}>
                <WaitingHoursBarChart
                  color="light"
                  title="Sub-Activity wise Hours Allocation"
                  description=""
                  date=""
                  chart={subActivityHoursChartData}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default SupervisorDashboard;
